import React, { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AddButton } from 'components/_basic/Form/FieldArray/components/AddButton';
import { FieldTableContainer } from 'components/_basic/Form/FieldTableContainer';

import { concatWithDot } from 'helpers/string';

import { IAveragePricesTableProps } from './types';
import {
  AVERAGE_PRICES_CHART_NAMES,
  MARKET_ANALYSIS_MAX_LENGTH,
  REGION_COLUMN_NAMES,
  regionProductsInitialValues,
  REGIONS_PRODUCT_NAMES,
} from '../../utils/form';
import { TableColumns } from '../TableColumns';
import { TableRow } from '../TableRow';

const columns = Object.values(REGION_COLUMN_NAMES);

const FIRST_COLUMN_WIDTH = 140;
const LAST_COLUMN_WIDTH = 36;

export const AveragePricesTable: FC<IAveragePricesTableProps> = ({ name, disabled }) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const rowsName = concatWithDot(name, AVERAGE_PRICES_CHART_NAMES.AVERAGE_PRICES_REGIONS_ROWS);
  const columnsName = concatWithDot(name, AVERAGE_PRICES_CHART_NAMES.AVERAGE_PRICES_REGIONS_HEADINGS);

  const { fields, append, remove } = useFieldArray({ control, name: rowsName });

  const canAddMore = fields.length < 5;

  const handleAddRow = () => {
    append(regionProductsInitialValues);
  };

  return (
    <FieldTableContainer>
      <TableColumns
        name={columnsName}
        columnsNames={columns}
        disabled={disabled}
        firstColumnWidth={FIRST_COLUMN_WIDTH}
        lastColumnWidth={LAST_COLUMN_WIDTH}
        inputMaxLength={50}
      />
      {fields.map((rowItem, index) => (
        <TableRow
          columnMultiline={false}
          key={rowItem.id}
          name={rowsName}
          rowIndex={index}
          columnsNames={columns}
          disabled={disabled}
          handleRemove={remove}
          firstColumnWidth={FIRST_COLUMN_WIDTH}
          lastColumnWidth={LAST_COLUMN_WIDTH}
          rowName={concatWithDot(rowsName, index.toString() || '', REGIONS_PRODUCT_NAMES.PRODUCT)}
          canDeleteFirstRow
          firstColumnMaxLength={MARKET_ANALYSIS_MAX_LENGTH.AVERAGE_PRICES.FIRST_COLUMN}
        />
      ))}
      <AddButton canAddMore={canAddMore} onClick={handleAddRow} disabled={disabled}>
        {t('global.products.buttonText')}
      </AddButton>
    </FieldTableContainer>
  );
};
